import * as ReactRedux from 'react-redux';
import { login, forgotPassword } from './auth.actions';
import { passwordEncode } from '../util/auth.util';
import { push } from 'react-router-redux';
import { paths } from '../app/app.routes';
import LoginComponent from './login.component';
import { AppState } from '../app/app.types';
import { getBusiness } from '../business/business.actions';

type OwnProps = {
  readonly isReLogin: boolean
};

const mapDispatchToProps = (dispatch: Function, props: OwnProps) => {
  return {
    onClickLogin: (email: string, password: string, fromEmailVerification: boolean) =>
      dispatch(login(email, passwordEncode(email, password), fromEmailVerification)),
    forgotPassword: (email: string) => dispatch(forgotPassword(email)),
    toDashboard: () => dispatch(push(paths.dashboard)),
    toAdminDashboard: () => dispatch(push(paths.adminDashboard)),
    toLogin: () => dispatch(push(paths.login)),
    getBusiness: () => dispatch(getBusiness())
  };
};

const mapStateToProps = (appState: AppState) => {
  return {
    authState: appState.authState,
    adminState: appState.adminState
  };
};

const Login = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(LoginComponent);

export default Login;



// WEBPACK FOOTER //
// ./src/auth/login.tsx